import React from "react";
import webui from "@tinqin/tinqin-web-ui";
import { xssFilter } from "../../../common/utils/xssFilter";
import { IComponentProps, SirenEntity } from "Common/utils/commonTypes";

export const Indicators: React.FC<IComponentProps> = props => {
    const data: Record<string, any> = props.data ? props.data.properties || {} : null;
    if (!data) {
        return null;
    }

    const buildChildren = (entities: SirenEntity[] = []) =>
        entities.map((item: SirenEntity, index: number) => {
            const { picto, text, alt }: Record<string, string> = item.properties;

            return (
                <div className="tq-flex-item" key={index}>
                    <img src={picto} alt={alt} />
                    <div
                        dangerouslySetInnerHTML={{
                            __html: xssFilter.process(text)
                        }}
                    ></div>
                </div>
            );
        });

    const children = props.data && props.data.entities;
    return <div className="tq-flex-container un-cp-indicators">{buildChildren(children)}</div>;
};

export default webui.connectComponent()(Indicators);
